const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'product_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_PRODUCTS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_PRODUCTS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_PRODUCTS':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_PRODUCTS':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_PRODUCT':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.product_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/products.js